import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const PayMethodService = {
  getAllPayMethod(obj) {
    return httpClient.post(endPoints.getPayMethod, obj);
  },
  updatePayMethod(obj) {
    return httpClient.post(endPoints.updatePayMethod, obj);
  },
  addPayMethod(obj) {
    return httpClient.post(endPoints.addPayMethod, obj);
  },
  deletePayMethod(obj) {
    return httpClient.post(endPoints.deletePayMethod, obj);
  },
};

export default PayMethodService;



// WEBPACK FOOTER //
// ./src/service/PayMethodService.js